export default __webpack_public_path__ + "static/media/shastasouthface.798f3238.jpg";